<template>
  <div class="popups-set-link">
    <!-- Connect Website Mirror -->
    <sweet-modal
      ref="modal-connect-mirror"
      title="Conexão Mirror"
      width="800px"
      v-if="website && user_to && user_from"
      hide-close-button
      blocking
    >
      <section class="cheetah-mirror-modal">
        <div class="card">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label for="mirror_domain" v-text="$t('ct-domain-connect')" />
                <input
                  type="text"
                  id="mirror_domain"
                  class="form-control"
                  v-model="mirrorDomain"
                  :placeholder="$t('ct-domain')"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label v-text="$t('ct-select-group-tags')" />
                <div class="dropdown-container">
                  <button
                    type="button"
                    class="btn btn-filter dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ mirrorName || $t('ct-groups') }}
                    <font-awesome-icon :icon="['fas', 'sort-down']" class="font-awesome-icon sort-icon"/>
                  </button>
                  <div class="dropdown-menu centered">
                    <a
                      class="dropdown-item"
                      v-for="group in tagGroups"
                      :key="group.id"
                      v-text="group.name"
                      @click="handleTagGroupMirror(group.id, group.name)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="form-group">
              <a
                href="/#/tags"
                class="cheetah-button cheetah-button-color-primary cheetah-button-size-small"
                v-text="$t('ct-tags-manager')"
              />
            </div>
            <div class="form-group d-flex align-items-center">
              <a
                href="/#/home"
                class="cheetah-button cheetah-button-color-light mr-4"
                v-text="$t('ct-cancel')"
              />
              <button
                @click="connectMirror"
                class="cheetah-button cheetah-button-color-success cheetah-button-size-large"
                v-text="$t('ct-domain-connect')"
              />
            </div>
          </div>
        </div>

      </section>
    </sweet-modal>
    <!-- Connect Website Mirror -->
    <sweet-modal
      ref="modal-public-link-confirm"
      width="60%"
      v-if="website && user_from"
      hide-close-button
      blocking
    >
      <section class="modal-confirm">
        <img class="modal-confirm-image" src="./../../../static/images/svg/screens.svg" alt="screens.svg">
        <h1 class="ba-montserrat-600 color-blue modal-confirm-title">{{$t('ct-free-template-waiting-for-you')}}</h1>
        <p v-if="user_to" class="mt-2 modal-confirm-text" v-html="$t('ct-click-add-template-to-my-account')"></p>
        <p v-else class="mt-2 modal-confirm-text" v-html="$t('ct-youve-just-received-a-free-website')"></p>
        <p class="mt-3 modal-confirm-label-box" style="margin-bottom: 0px !important;">
          <span class="modal-confirm-label">{{ $t('ct-website')}}:</span>
          <span>{{ website.title }}</span>
        </p>
        <p class="mt-2 mb-2 modal-confirm-label-box">
          <span class="modal-confirm-label">{{ $t('ct-from')}}:</span>
          <span>{{ user_from.name }} (ID: {{ user_from.id_office_user }})</span>
        </p>
        <template v-if="user_to">
          <p class=" mb-5 modal-confirm-label-box">
            <span class="modal-confirm-label">{{ $t('ct-to')}}:</span>
            <span>{{ user_to.email }}</span>
            <a :href="officeLogoutRedir">{{$t('ct-switch-account')}}</a>
          </p>
        </template>

        <!-- seila pra que serve isso aqui. na duvida nao mexe -->
        <div v-if="website.template_tag">
          <div v-if="tagGroups.length > 0">
            <span class="subtitle">{{$t('ct-select-tag-group-label')}}</span>
            <button
              type="button"
              class="btn btn-filter dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon :icon="['fas', 'sort']" class="font-awesome-icon sort-icon" />
              {{ groupSelect.name || $t('ct-groups')}}
            </button>
            <div class="dropdown-menu centered">
              <span
                v-for="group in tagGroups"
                :key="group.id"
                href="#"
                class="dropdown-item"
                @click="chooseTagGroup(group)"
              >{{ group.name }}</span>
            </div>
          </div>
          <div v-else>
            <button
              class="btn btn-primary"
              @click="$router.push({ name: 'Tags' })"
            >{{ $t('ct-create-tag-group')}}</button>
          </div>
        </div>
      </section>

      <!-- user logged -->
      <button v-if="user_to" slot="button" class="btn btn-primary" @click.prevent="confirm">{{$t('ct-add-template-to-my-account')}}</button>

      <!-- non logged -->
      <div v-else slot="button">
        <a class="btn btn-primary mb-2" :href="`${officeUrl}/us/office/login?redir=${publicLinkRedir}`">{{$t('ct-login-to-add-my-account')}}</a>
        <br>
        <a :href="`${checkoutUrl}/payment/bundle-plan?url-after-payment=${publicLinkRedir}&aid=${user_from.id_office_user}`">{{$t('ct-dont-heve-builderall-account')}}</a>
      </div>
    </sweet-modal>

    <sweet-modal

      ref="modal-public-link-success"
      v-if="website_new"
      width="50%"
      hide-close-button
      blocking
    >
      <section>
        <img class="modal-success-image" src="./../../../static/images/svg/confetti.svg" alt="confetti.svg">
        <h1 class="ba-montserrat-600 color-blue modal-success-title">{{$t('ct-you-template-is-ready')}}</h1>
        <p class="modal-success-text" v-html="$t('ct-template-has-been-added-to-your-account')"></p>
      </section>
      <div style="display: flex; justify-content: center;">
        <a
        slot="button"
        class="modal-success-button"
        :href="`${officeUrl}/us/office/cheetah-builder`"
      >{{ $t('ct-go-to-site-dashboard')}}</a>

      </div>

    </sweet-modal>

    <sweet-modal
      ref="modal-public-link-error"
      v-if="website_new"
      width="35%"
      hide-close-button
      blocking
    >
      <section>
        <h1 class="mt-4">{{ $t('ct-public-link-error') }}</h1>
        <h2 class="mt-4" v-if="is_free">{{ $t('ct-public-link-user-free') }}</h2>
      </section>

      <button
        slot="button"
        class="btn btn-dark m-0"
        @click.prevent="goToHome"
      >{{ $t('ct-go-to-home')}}</button>
    </sweet-modal>

    <!--
    <sweet-modal

      ref="modal-public-link-login"
      width="40%"
      v-if="website"
      hide-close-button
      blocking
    >
      <section>
        <h1 class="my-4">{{ $t('ct-public-link-need-login')}}</h1>

        <form class="mx-5" @submit.prevent="submitLogin" method="POST">
          <div class="form-group">
            <label for="email">{{ $t('ct-email')}}</label>
            <input
              type="email"
              id="email"
              class="form-control"
              v-model="user.email"
              :class="{'is-invalid': errors && errors.email}"
              required
            />

            <span v-if="errors.email" class="invalid-feedback" v-text="errors.email[0]"></span>
          </div>
          <div class="form-group">
            <label for="password">{{ $t('ct-password')}}</label>
            <input
              type="password"
              id="password"
              class="form-control"
              v-model="user.password"
              :class="{'is-invalid': errors && errors.password}"
              required
            />
            <span v-if="errors.password" class="invalid-feedback" v-text="errors.password[0]"></span>
          </div>
          <div class="form-group text-center">
            <button type="submit" class="btn btn-primary text-center">{{ $t('ct-login')}}</button>
          </div>
        </form>
      </section>
    </sweet-modal>
    -->
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import { mapGetters } from "vuex";
import { get, save } from "./../../js/services/editor/publicLink";
import { getGroups } from "./../../js/services/editor/autotag";
import { connect as connectMirrorWebsite } from "./../../js/services/editor/mirror";

import { login } from "./../../js/services/editor/login";
export default {
  name: "PublicLinkSave",
  components: { SweetModal },
  data() {
    return {
      mirrorDomain: '',
      mirrorGroup: '',
      mirrorName: '',
      is_free: false,
      website: { encrypted_id: "" },
      website_new: {},
      user_to: { name: String(), email: String() },
      user_from: { name: String(), email: String() },
      user: {
        email: "",
        password: ""
      },
      errors: "",
      tagGroups: [],
      groupSelect: {
        id: "",
        name: ""
      }
    };
  },
  computed: {
    officeLogoutRedir() {
      return this.officeUrl + '/us/office/logout?redir='+ encodeURIComponent('/us/office/login?redir=' + this.publicLinkRedir)
    },
    publicLinkRedir() {
      return encodeURIComponent(location.href+'?skip-confirmation=1')
    },
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
    },
    checkoutUrl(){
      return location.host.indexOf('kub.app.builderall') > -1 ? 'https://checkoutfront.kub.app.builderall.io' : 'https://checkout.builderall.com';
    }
  },
  methods: {
    handleTagGroupMirror(id, name) {
      this.mirrorGroup = id
      this.mirrorName = name
    },
    connectMirror() {


      this.mirrorDomain = this.mirrorDomain.replace('http://', '');
      this.mirrorDomain = this.mirrorDomain.replace('https://', '');
      this.mirrorDomain = this.mirrorDomain.replace('www.', '');
      this.mirrorDomain = this.mirrorDomain.replace('/', '');

       let dataStore = {
         website_id: this.website.encrypted_id,
         domain: this.mirrorDomain,
         user_email:  this.user_to.email,
         tag_group:  this.mirrorGroup,
       }

       if(dataStore.tag_group === ''){
          this.$snotify.error(
              this.$t(
                "ct-select-group-tags",
                "Please, select a valid tag group"
              )
            );
            return;
       }

       if(dataStore.domain === ''){
          this.$snotify.error(
              this.$t(
                "ct-input-a-valid-domain",
                "Please, insert a valid domain"
              )
            );
            return;
       }

        connectMirrorWebsite(dataStore)
        .then( ({ data }) => {

          if( data.success) {
            this.$snotify.success(
              this.$t(data.message || 'Mirror connected with success')
            )

            setTimeout(() => {
              this.$router.push({
                name: 'Home'
              })
            }, 4000)
          }
          else {
            this.$snotify.error(
            this.$t(
              data.error
            )
          );

           }
        } )
    },

    ...mapGetters({ getUser: "user" }),
    confirm() {

      this.$loading.show();

      this.$nextTick(()=>{

        console.log(this.$data);
        this.$data.type = "";
        this.$data.group = "";

        if (this.website.template_tag) {
          if (this.groupSelect.id === "") {
            this.$loading.hide();
            this.$snotify.error(
              this.$t(
                "ct-select-tag-group",
                "Something happened when trying to publish your site, check the settings"
              )
            );
            return;
          } else {
            this.$data.type = "smartTemplate";
            this.$data.group = this.groupSelect.id;
          }
        }

        this.$loading.show();

        save(this.$data)
          .then(response => {
            if (response.data.success) {
              this.is_free = false;
              this.website_new = response.data.data;
              this.$refs["modal-public-link-confirm"].close();
              this.$refs["modal-public-link-success"].open();
            } else {
              if (response.data.is_free) {
                this.is_free = true;
              }
              this.website = {};
              this.$refs["modal-public-link-confirm"].close();
              this.$refs["modal-public-link-error"].open();
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$snotify.error(this.$t('ct-plan-limited-transfer'));
            } else {
              this.website = {};
              this.$refs["modal-public-link-confirm"].close();
              this.$refs["modal-public-link-error"].open();
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
        })
    },

    goToSiteDashboard() {
      this.$refs["modal-public-link-success"].close();
      this.$router.push({
        name: "Home",
      });
    },

    goToHome() {
      this.$refs["modal-public-link-confirm"].close();
      this.$router.push({ name: "Home" });
    },

    control() {
      const vm = this;
      let resolved = false;

      const xhttp = new XMLHttpRequest();
      xhttp.withCredentials = true;

      xhttp.open(
        "GET",
        `${this.officeUrl}/us/office/login-status`,
        true
      );

      xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");

      // fallback de segurança
      const fallback = setTimeout(() => {
        if (!resolved) {
          resolved = true;
          vm.getAuth(); // segue fluxo SEM login
        }
      }, 1500);

      xhttp.onreadystatechange = function () {
        if (xhttp.readyState === 4) {
          clearTimeout(fallback);

          if (xhttp.status === 200) {
            try {
              const res = JSON.parse(xhttp.responseText);
              resolved = true;

              if (res.isLogged && res.email) {
                vm.login({
                  email: res.email,
                  password: "senhaSuperSecreta879"
                });
              } else {
                vm.getAuth();
              }
            } catch (e) {
              vm.getAuth();
            }
          } else {
            vm.getAuth();
          }
        }
      };

      xhttp.onerror = function () {
        clearTimeout(fallback);
        vm.getAuth();
      };

      xhttp.send();
    },

    getAuth() {
      this.getData();

      getGroups().then(({ data }) => {
        console.log('getGroups finished', data);
        this.tagGroups = data;
      }).catch(error => {
        console.log('getGroups error', error);
      });
    },

    chooseTagGroup(group) {
      this.groupSelect = group;
    },

    login(user) {
      // console.log('chamou login')
      this.$loading.show();

      login(user)
        .then(data => {
          let response = data.data;

          if (response.success) {
            window.token = response.token;

            this.$store.dispatch("updateUser", response.user);

            localStorage.token = response.token;
            localStorage.setItem("login", true);
            localStorage.setItem("username", response.user.name);
            localStorage.setItem("token", response.token);

            //this.$refs["modal-public-link-login"].close();
            this.getAuth();
          } else {
            this.errors = {};
            this.errors.message = response.error;
            this.$loading.hide()
          }
        })
        .catch(error => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
            this.errors.message = error.response.data.message;
            this.$loading.hide()
            this.getAuth();
          }
        })
        // .finally(() => this.$loading.hide());
    },
    /*
    submitLogin() {
      if (this.user.email && this.user.password) {
        this.login(this.user);
      }
    },
    */

    getData() {
      this.$loading.show();
      get(this.website)
      .then(response => {
        if (response.data.success) {
          let data = response.data.data;
          this.website = data.website;
          this.user_to = data.user_to;
          this.user_from = data.user_from;


          console.log(this.website);

          if(this.website.is_mirror) {
            this.$refs["modal-connect-mirror"].open();
          }else{
            if ('skip-confirmation' in this.$route.query && this.user_from && this.user_to) {
              this.confirm()
            } else {
              this.$refs["modal-public-link-confirm"].open();
            }
          }
        } else {
          this.website = {};
          this.$refs["modal-public-link-error"].open();
        }
      })
      .catch(() => {
        this.website = {};
        this.$refs["modal-public-link-error"].open();
      })
      .finally(() => {
        this.$loading.hide();
      });
    }
  },
  created() {
    this.$loading.show();
  },
  mounted() {
    this.website.encrypted_id = this.$route.params.website_id;
    this.control();
  }
};
</script>

<style lang="scss">
  .popups-set-link {
    .sweet-modal {
      height: auto !important;
      max-height: 500px;
    }
  }
</style>

<style lang="scss" scoped>

.cheetah-mirror-modal {

  label {
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    color: #6E6E6E;

    text-transform: capitalize;
  }

  .cheetah-button-color {
    &-primary:hover {
      color: #F8FAFD;
      text-decoration: none;
    }

    &-light:hover {
      color: #5A5959;
      text-decoration: none;
    }
  }

  .dropdown-container {

    .dropdown-toggle {
      width: 100%;
      justify-content: space-between !important;

      font-family: 'Lato', sans-serif !important;
      font-size: 14px !important;
      color: #656565;

      border: 1px solid #DDDDDD;
      margin: 0;
      z-index: 2;
    }

    .dropdown-menu {
      max-height: 100px;
      overflow: auto;
    }

    .dropdown-item {
      font-family: 'Muli', sans-serif !important;
      font-size: 14px;
      font-weight: normal !important;
      color: #656565;

      cursor: pointer;
    }
  }
}


.sweet-buttons,
.sweet-content-content {
  // font-family: Muli;
}

section {
  font-family: Muli;
  h1 {
    font-weight: bold;
    font-size: 20px;
    color: #434343;
  }

  h2 {
    color: #5a5959;
    font-size: 18px;
  }

  p {
    font-size: 17px;
    color: #5a5959;

    span:first-child {
      font-weight: bold;
    }
  }

  .link-text {
    font-size: 20px;
    color: #434343;
  }

  .color-blue{
    color: #0072E1 !important;
  }

  .modal-confirm-title{
    margin-top: 76px !important;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
}
  .modal-confirm-image{
    position: absolute;
    top: -172px;
    left: 27%;
  }
  .modal-confirm-text{
    font-size: 17px;
    color: #8D9EB5;
    font-weight: 500;
    width: 100%;
    border-bottom: 1px solid rgba(77, 93, 113, 0.25);
    padding-bottom: 8px;
    padding-top: 8px;
  }
  .modal-confirm-label-box{
    font-size: 14px !important;

  }
  .modal-confirm-label{
    font-weight: 600;
    font-size: 16px;
  }

  .modal-success-image{
    position: absolute;
    top: -45px;
    left: 37%;

  }
  .modal-success-title{
    margin-top: 50px;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }
  .modal-success-text{
    font-size: 16px;
    color: #8D9EB5;
    font-weight: 500;
    text-align: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/PublicLinkSave.vue